var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.client.Longitude && !_vm.location.HideMapFromBookingProcess)?_c('div',{staticClass:"location_map mb-3"},[_c('h3',{staticClass:"mt-3"},[_vm._v("Location")]),_c('p',[_c('a',{attrs:{"target":"_blank","href":_vm.mapLink}},[_vm._v(_vm._s(_vm.locationString))])]),_c('div',{attrs:{"id":"map"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }